// extracted by mini-css-extract-plugin
module.exports = {"cartFooterContainer":"cart-footer_cartFooterContainer___t9WU"};